import React from 'react';
import { observer } from 'mobx-react-lite';

import { useStore } from '../core/store';

export const MtsWidgetDisplay = observer(() => {
  const { booking } = {
    ...useStore().BookingStore,
  };

  return (
    <div className="h-full overflow-auto lg:pt-0 lg:pb-0 lg:pl-[300px]">
      <iframe
        id="mtsActivityContentFrame"
        className="block h-[100vh] w-full overflow-hidden border-none pt-[64px] pb-[85px]"
        type="text/html"
        src={`https://tkw.axisdata.net/mtsactivity.html?version=1698054583&horizontal=true&linkout=false&apikey=nSSvtS5L6NDmQcYzN8&lang=en&displayheader=false&category=&background=FFFFFF&primarycolor=881467&secondarycolor=881467&reference=${booking?.data?.transferReference}&style=true`}
      ></iframe>
    </div>
  );
});
